var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tdAttr.show)?_c('div',{staticClass:"h-100 w-100 cursor-pointer d-flex justify-content-center",on:{"click":_vm.data.toggleDetails}},[_c('feather-icon',{attrs:{"icon":_vm.icon,"size":"18"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }